module.exports = __webpack_public_path__ + "img/精致美型--大眼gif.df1ffff0.gif";